import { Component, OnInit } from '@angular/core';
import { ChangeLog, ChangeLogService } from '@services/change-log.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'scaffold-changelog',
  templateUrl: './changelog.component.html',
  styleUrls: ['./changelog.component.scss']
})  

export class ChangelogComponent implements OnInit {
  changes: ChangeLog[] = [];
  page = 1;
  constructor(public changeService: ChangeLogService) { }

  ngOnInit(): void {
    this.getChangePage(1);
  }
  /**
   * Get the changes in a specific page;
   * @param page page to get
   */
  getChangePage(page) {
    this.changeService.getChanges(page).pipe(take(1)).subscribe(c => this.changes = c);
  }

}
